if(!customElements.get('announcement-bar')){
    class AnnouncementBar extends HTMLElement {
        constructor(){
            super();
            
            this.validate();
        }

        connectedCallback(){
            this.timeInterval = parseInt(this.dataset.timeInterval);
            this.announcementNum = 1;
            this.announcements = this.querySelectorAll('.announcement__content');
  
            this.updateAnnouncement();

            this.updateMainMargin();
            this.updateTopPosition();
            window.addEventListener('resize', this.updateTopPosition.bind(this));

            this.themeEditorUpdateUnSubscriber = PubSub.subscribe(PubSub.events.themeEditorUpdate, this.refreshSection.bind(this));
        
            // close the announcement bar
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener("click", this.close.bind(this));
                item.addEventListener("keydown", (e) => {
                    if(e.key === 'Enter' || e.key === ' '){
                        e.preventDefault();
                        this.close();
                    }
                });
            });
        }

        disconnectedCallback(){
            if(this.themeEditorUpdateUnSubscriber){
                this.themeEditorUpdateUnSubscriber();
            }
        }

        validate(){
            // check if cookie exists
            if(getCookie('announcement-bar-closed')){
                this.close(true);
                return;
            }

            this.open();
        }

        open(){
            this.setAttribute('data-hidden', 'false');
            this.updateMainMargin();
        }

        close(loading = false){
            setCookie('announcement-bar-closed', 'true', 1);
            sessionStorage.setItem('announcement-bar-closed', 'true');

            this.setAttribute('data-hidden', 'true');

            const emptyHeight = 0;
            this.updateMainMargin(emptyHeight, loading);

            this.closest(".section-header")?.setAttribute('data-closed', 'true');
            PubSub.publish(PubSub.events.themeEditorUpdate, {});
        }

        refreshSection(){
            setTimeout(() => {
                this.updateTopPosition();
                this.updateMainMargin();
            }, 100);
        }

        updateAnnouncement(){
            if(this.announcements.length > 1){
                setInterval(() => {
                    this.announcements.forEach(item => {
                        item.setAttribute('data-hidden', 'true');
                        item.setAttribute('inert', '');
                    });
                    if(this.announcements[this.announcementNum - 1]){
                        this.announcements[this.announcementNum - 1].setAttribute('data-hidden', 'false');
                        this.announcements[this.announcementNum - 1].removeAttribute('inert');
                    }
                    this.announcementNum = this.announcements.length === this.announcementNum? 1 : this.announcementNum + 1;
                }, this.timeInterval);
            }
        }

        updateMainMargin(emptyHeight = null, marginTransition = false){
            const height = emptyHeight !== null? emptyHeight : this.offsetHeight;
            const main = document.querySelector('main');

            if(!main) return;

            if(emptyHeight !== null){
                if(marginTransition){
                    // slowly remove the margin to avoid sudden jump
                    let currentHeight = parseInt(getComputedStyle(main).getPropertyValue('--announcement-bar-gap')) || 0;
                    const step = (currentHeight - height) / 10;
                    
                    const interval = setInterval(() => {
                        currentHeight = currentHeight - step;
                        if(currentHeight <= height){
                            currentHeight = height;
                            clearInterval(interval);
                        }
                        main.style.setProperty('--announcement-bar-gap', `${currentHeight}px`);
                    }
                    , 20);
                }else{
                    main.style.setProperty('--announcement-bar-gap', `${height}px`);
                }
                return;
            }

            main.style.setProperty('--announcement-bar-gap', `${height}px`);
        }

        updateTopPosition(){
            const sectionHeaders = Array.from(document.querySelectorAll('.section-header'));
            let topPosition = 0;
            sectionHeaders.some(item => {
                const headerElement = item.querySelector(".header-element");
                const style = getComputedStyle(headerElement);

                if(headerElement === this){
                    return true;
                }else{
                    topPosition = topPosition + headerElement.offsetHeight + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
                }
            });

            this.style.setProperty('--top', `${topPosition}px`);
        }
    }

    customElements.define('announcement-bar', AnnouncementBar);
}